export default {
  common: {
    error: "Noget gik galt",
    reload: "Genindlæs",
    errorNotification: "Vi er blevet underrettet og vil rette det så hurtigt som muligt. Hvis problemet fortsætter, bedes du",
    contactUs: "kontakte os.",
    language: "Sprog",
    loading: "Indlæser...",
    loadingText: "Indlæser",
    save: "Gem",
    savedSuccessfully: "Gemt Med Succes",
    saving: "Gemmer...",
    cancel: "Annuller",
    edit: "Rediger",
    delete: "Slet",
    add: "Tilføj",
    search: "Søg",
    filter: "Filter",
    clear: "Ryd",
    preview: "Forhåndsvisning",
    default: "Standard: {{value}}",
    optional: "Valgfrit",
    required: "Påkrævet",
    noData: "Ingen data",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "Lokationer",
      cities: "Byer", 
      regions: "Regioner",
      countries: "Lande",
      showOnMap: "Vis på kort",
      addLocation: "Tilføj lokation"
    },
    welcome: {
      title: "Velkommen til Locations So Super.",
      subtitle: "Vælg en sektion fra navigationen for at komme i gang."
    }
  },

  // Cities section
  cities: {
    title: "Byer",
    resourceSingular: "by",
    resourcePlural: "byer",
    headings: {
      name: "Navn",
      status: "Status",
      locations: "Lokationer", 
      region: "Region",
      country: "Land"
    },
    breadcrumbs: {
      cities: "Byer"
    }
  },

  // Countries section  
  countries: {
    title: "Lande",
    resourceSingular: "land", 
    resourcePlural: "lande",
    headings: {
      name: "Navn",
      status: "Status",
      locations: "Lokationer",
      cities: "Byer",
      regions: "Regioner"
    },
    breadcrumbs: {
      countries: "Lande"
    }
  },

  // Regions section
  regions: {
    title: "Regioner",
    resourceSingular: "region",
    resourcePlural: "regioner", 
    headings: {
      name: "Navn",
      status: "Status",
      locations: "Lokationer",
      cities: "Byer",
      country: "Land"
    },
    breadcrumbs: {
      regions: "Regioner"
    }
  },

  // Map section
  map: {
    title: "Kort",
    breadcrumbs: {
      locations: "Lokationer"
    }
  },

  // Import section
  import: {
    title: "CSV Import",
    breadcrumbs: {
      locations: "Lokationer"
    },
    new: {
      title: "Import lokationer via CSV",
      description: "Download en eksempel CSV-skabelon for at se et eksempel på det krævede format",
      sampleTemplate: "eksempel CSV-skabelon",
      uploadAndContinue: "Upload og fortsæt",
      abortOnError: "Afbryd ved fejl",
      abortOnErrorHelp: "Hvis der er en fejl, vil importen afbryde, vise fejlen og ingen lokationer vil blive importeret.",
      needHelp: "Har brug for hjælp til at importere lokationer?"
    },
    show: {
      title: "CSV import",
      youCanLeavePage: "Du kan forlade denne side",
      backgroundMessage: "Din import vil stadig køre i baggrunden",
      importProgress: "Import fremskridt",
      imported: "Importeret",
      suffix: "lokationer",
      importLog: "Import log",
      cancelImport: "Annuller import",
              cancelConfirmation: {
          title: "Annuller import",
          message: "Er du sikker på, at du vil annullere denne importopgave? Denne handling kan ikke fortrydes.",
          note: "Bemærk: For igangværende opgaver skal opgaven fuldføres og den vil blive slettet lige efter.",
          yesCancel: "Ja, annuller import",
          noContinue: "Nej, fortsæt import"
        },
              report: "Rapport",
        failedLocations: "Mislykkede lokationer",
        uploadAnother: "Upload en anden CSV",
        backToLocations: "Tilbage til lokationer",
        importSucceeded: "Import lykkedes",
        importFailed: "Import mislykkedes"
    },
    messages: {
      uploadSuccess: "CSV uploadet med succes",
      uploadError: "Kunne ikke uploade CSV",
      pending: "Import er ikke startet endnu",
      inProgress: "Import i gang",
      completed: "Import fuldført",
      invalidHeader: "Følgende kolonner er påkrævet",
      invalidCsvFile: "Ugyldig CSV-fil",
      aborted: "Import afbrudt",
      failed: "Import mislykkedes",
      cancelled: "Import annulleret"
    },
    errors: {
      csvTooLarge: "CSV er for stor",
      languageNotEnabled: "Sproget '{{language}}' er ikke aktiveret for denne butik. Aktiver det venligst i Indstillinger > Sprog først.",
      fieldNotTranslatable: "Feltet '{{field}}' er ikke oversætteligt. Oversættelige felter er: {{fields}}",
      locationError: "Lokation med slug: {{slug}} - {{error}}",
      planLimit: "Du er på din planbegrænsning for lokationer"
    }
  },

  // Location form
  location: {
    index: {
      title: "Lokationer",
      addLocation: "Tilføj lokation",
      import: "Import",
      noPrioritySet: "Ingen prioritet sat",
      published: "Offentliggjort",
      draft: "Kladder",
      resourceSingular: "lokation",
      resourcePlural: "lokationer",
      headings: {
        name: "Navn",
        status: "Status", 
        city: "By",
        region: "Region",
        country: "Land",
        priority: "Prioritet"
      }
    },
    form: {
      title: "Tilføj lokation",
      editTitle: "Rediger lokation",
      basicInformation: "Grundlæggende information",
      name: "Navn",
      namePlaceholder: "f.eks. Brians Mursten",
      nameHelpDefault: "Standard: {{defaultName}}",
      details: "Detaljer",
      description: "Beskrivelse",
      descriptionPlaceholder: "Fortæl kunderne, hvad der gør denne lokation særlig",
      address: "Adresse",
      addressPlaceholder: "123 Hovedgade, By, Land",
      addressLine1: "Adresselinje 1",
      addressLine2: "Adresselinje 2",
      postalZipCode: "Postnummer",
      city: "By",
      stateProvinceRegion: "Stat / Provins / Region",
      country: "Land",
      phone: "Telefon",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "E-mail", 
      emailPlaceholder: "store@example.com",
      website: "Hjemmeside",
      websitePlaceholder: "https://www.example.com",
      image: "Billede",
      imagePlaceholder: "Indtast billede URL",
      status: "Status",
      statusActive: "Aktiv",
      statusInactive: "Inaktiv",
      statusDraft: "Kladder",
      priority: "Prioritet",
      priorityHelpText: "Lokationer med højere prioritet vises først i søgeresultater",
      findOnMapButton: "Find på kort"
    },
    validation: {
      addressNotFound: "Kunne ikke finde adresse",
      createSuccess: "Lokation oprettet succesfuldt", 
      updateSuccess: "Lokation opdateret succesfuldt",
      checkFields: "Kontroller venligst dine felter",
      findOnMap: "Find venligst din lokation på kortet før du gemmer"
    },
    errors: {
      loading: "Fejl ved indlæsning af lokation"
    },
    actions: {
      save: "Gem lokation",
      delete: "Slet lokation",
      preview: "Forhåndsvisning"
    },
    customFields: {
      title: "Tilpassede felter",
      noCustomFields: "Ingen tilpassede felter konfigureret",
      configureFields: "Konfigurer felter",
      emptyState: "Du har ikke konfigureret nogen tilpassede felter endnu. Tilpassede felter giver dig mulighed for at tilføje yderligere information specifik for dine forretningsbehov."
    },
    openingHours: {
      title: "Åbningstider",
      checkboxLabel: "Denne lokation har åbningstider og lukketider",
      statusOpen: "Åben",
      statusOpen24h: "Åben 24T",
      statusClosed: "Lukket",
      openingTimeLabel: "Åbningstid",
      closingTimeLabel: "Lukketid",
      days: {
        monday: "Mandag",
        tuesday: "Tirsdag", 
        wednesday: "Onsdag",
        thursday: "Torsdag",
        friday: "Fredag",
        saturday: "Lørdag",
        sunday: "Søndag"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Nyligt tilføjet",
        recentlyModified: "Nyligt ændret"
      },
      filters: {
        status: "Status",
        taggedWith: "Tagget med",
        locationStatus: "Lokationsstatus",
        noTagsToShow: "Ingen tags at vise",
        searchPlaceholder: "Søg"
      },
      bulkActions: {
        setPublished: "Sæt som offentliggjort",
        setUnpublished: "Sæt som ikke offentliggjort", 
        setPriority: "Sæt prioritet",
        deleteLocations: "Slet lokationer",
        exportCSV: "Eksporter som CSV"
      },
      appliedFilters: {
        statusIs: "Status er {{status}}",
        taggedWith: "Tagget med {{tag}}",
        nameIncludes: "Navn indeholder {{search}}"
      },
      modals: {
        deleteTitle: "Slet lokationer",
        deleteMessage: "Er du sikker på, at du vil slette {{count}}?",
        deleteMessageAll: "Er du sikker på, at du vil slette alle lokationer?",
        prioritiseTitle: "Prioriter {{count}} lokationer",
        prioritiseTitleAll: "Prioriter alle lokationer",
        delete: "Slet",
        cancel: "Annuller"
      },
      emptyState: {
        noResultsHeading: "Kunne ikke finde nogen {{resourcePlural}}",
        noResultsText: "Prøv at ændre filtrene eller søgetermen",
        noDataHeading: "Tilføj en lokation for at udfylde {{resourcePlural}}",
        addLocation: "Tilføj lokation",
        importFromCSV: "Import fra CSV"
      },
      pagination: {
        label: "Side {{page}} af {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Opdateret succesfuldt",
        deletedSuccessfully: "Slettet succesfuldt", 
        exportedSuccessfully: "Eksporteret succesfuldt",
        error: "Noget gik galt"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Sideindhold",
    editTemplate: "Rediger SEO-skabelon", 
    pageTitle: "Titel",
    pageDescription: "Beskrivelse",
    metaTitle: "Titel",
    metaDescription: "Beskrivelse",
    urlHandle: "URL-håndtag",
    searchEnginePreview: "Søgemaskine liste forhåndsvisning",
    editMeta: "Rediger Meta",
    previewMeta: "Forhåndsvis Meta",
    loading: "Indlæser...",
    editingLocaleHelp: "Redigerer {{locale}} indhold."
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO-skabeloner",
    breadcrumbs: {
      seoTemplates: "SEO-skabeloner"
    },
    template: {
      title: "{{templateName}} skabelon - {{locale}}",
      discardChanges: "Kassér ændringer"
    },
    form: {
      pageContent: "Sideindhold",
      searchEnginePreview: "Søgemaskine liste forhåndsvisning",
      title: "Titel",
      description: "Beskrivelse",
      pageTitle: "Sidetitel",
      metaDescription: "Meta-beskrivelse",
      editingLocaleHelp: "Redigerer {{locale}} oversættelser. Tomme felter vil vise indhold fra {{defaultLocale}}.",
      defaultValue: "Standard: {{value}}"
    },
    language: {
      label: "Sprog",
      defaultHelp: "Dette er dit standardsprog",
      editingHelp: "Redigerer {{locale}} oversættelser. Tomme felter vil vise {{defaultLocale}} indhold."
    },
    banner: {
      multipleLanguagesDisabled: "Flere sprog ikke aktiveret",
      enableInSettings: "Aktiver i Indstillinger",
      multipleLanguagesInfo: "For at administrere SEO-skabeloner for flere sprog, aktiver internationalisering i dine sprogindstillinger. Viser i øjeblikket kun {{locale}} skabeloner."
    },
    badges: {
      errors: "Fejl!",
      unsaved: "Ikke gemt"
    },
    messages: {
      saveSuccess: "SEO-skabeloner gemt succesfuldt",
      saveError: "Kunne ikke gemme skabeloner",
      error: "Fejl..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Grundlæggende information",
      name: "Navn",
      save: "Gem",
      saving: "Gemmer...",
      cancel: "Annuller",
      yourLocationsIn: "Dine lokationer i {{name}}",
      tableHeadings: {
        name: "Navn",
        status: "Status",
        city: "By",
        region: "Region",
        country: "Land"
      },
      resourceName: {
        singular: "{{name}} lokation",
        plural: "lokationer i {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Kort",
      tags: "Tags",
      customFields: "Tilpassede felter",
      languages: "Sprog",
      plan: "Plan",
      addTag: "Tilføj tag",
      addField: "Tilføj felt"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Slutter snart"
    },
    common: {
      loading: "Indlæser...",
      error: "Fejl...",
      breadcrumbs: {
        settings: "Indstillinger"
      },
      skeleton: {
        customFields: "Tilpassede felter",
        addField: "Tilføj felt",
        name: "Navn",
        contentType: "Indholdstype",
        usedIn: "Bruges i",
        field: "Felt",
        fields: "Felter"
      },
      messages: {
        savedSuccessfully: "{{setting}} indstillinger gemt med succes",
        couldntSave: "Kunne ikke gemme {{setting}} indstillinger"
      }
    },
    map: {
      title: "Kort",
      messages: {
        savedSuccessfully: "Kortindstillinger gemt med succes",
        couldntSave: "Kunne ikke gemme indstillinger"
      },
      mapboxToken: {
        title: "Mapbox token",
        description: "Indtast din Mapbox token for at drive din butikslokator",
        label: "Mapbox token",
        placeholder: "Indtast token her for at fortsætte med at bruge dit kort.",
        placeholderManaged: "Indtast token her for at fortsætte med at bruge dit kort, når du løber tør for gratis kortbelastninger.",
        helpText: "Følg vores instruktioner til at oprette en Mapbox nøgle, og sæt derefter din nøgle ind ovenfor. Hvis du støder på problemer, bedes du kontakte os for hjælp.",
        linkInstructions: "instruktioner til at oprette en Mapbox nøgle",
        linkSupport: "kontakt os for hjælp"
      },
      managedToken: {
        title: "Kortbelastninger",
        description: "Du har op til {{max}} gratis kortbelastninger med en administreret token, efter det skal du oprette din egen token."
      },
      appearance: {
        title: "Udseende",
        description: "Ændr udseendet af dit kort"
      },
      mapStyle: {
        title: "Kortstil",
        options: {
          streets: "Gader",
          outdoors: "Udendørs", 
          light: "Lys",
          dark: "Mørk",
          satellite: "Satellit",
          satelliteStreets: "Satellitgader",
          navigationDay: "Navigation dag",
          navigationNight: "Navigation nat"
        }
      },
      searchBehaviour: {
        title: "Søgeadfærd",
        description: "Styrer hvordan besøgende finder lokationer på dit kort.",
        geolocateLabel: "Automatisk estimer besøgendes placering og vis nærliggende butikker",
        geolocateHelp: "Hvis geolokalisering lykkes, vil kortet flytte sig for at fokusere nær besøgenden. Hvis en estimeret placering ikke kan findes, vil kortet forblive i startpositionen.",
        filterBehaviour: {
          title: "Filteradfærd",
          all: {
            label: "Alle tags",
            help: "For at en lokation skal vises i filtre, skal den have alle de valgte tags"
          },
          any: {
            label: "Alle tags", 
            help: "For at en lokation skal vises i filtre, kan den have nogle af de valgte tags"
          }
        },
        keepSearchInView: {
          label: "Hold søgemarkør i syn",
          help: "Når søgeresultater vises, vil kortet zoome ud for at vise alle matchende lokationer"
        },
        distanceUnits: {
          title: "Afstandsenheder",
          km: "Kilometer",
          miles: "Miles"
        },
        maxResults: {
          label: "Maks resultater",
          help: "Begræns antallet af lokationer vist i søgeresultater",
          options: {
            results30: "30 resultater"
          }
        },
        maxDistance: {
          label: "Maks afstand", 
          help: "Vis kun lokationer inden for denne afstand fra søgepunktet",
          options: {
            unlimited: "Ubegrænset"
          }
        },
        showLocationNames: {
          label: "Vis lokationsnavne i forslag",
          help: "Vis lokationsnavne i søgeforslag"
        },
        sortByPriority: {
          label: "Sortér efter prioritet i stedet for afstand",
          help: "Det anbefales stærkt at sætte en maksimal afstand (som ikke er Ubegrænset), hvis denne boks er markeret. Ellers vil dine kunder se fjerne lokationer, der har høj prioritet, listet over dem, der er inden for en rimelig afstand fra dem (eller deres søgeforespørgsel, mere specifikt)."
        }
      },
      searchResults: {
        title: "Søgeresultater",
        description: "Styrer hvordan lokationer returneres på dit kort.",
        locationsLabel: "Søgeresultat tekst",
        locationsHelp: "Tekst vist over søgeresultater (f.eks. 'Viser 5 lokationer')",
        prefixLabel: "Søgeresultat præfiks", 
        prefixHelp: "Tekst vist før antallet af resultater"
      },
      popups: {
        title: "Popup-vinduer",
        showPopups: {
          label: "Vis popup-vinduer",
          help: "Vis lokationsdetaljer når besøgende klikker på kortmarkører"
        }
             },
       whitelabel: {
         title: "Whitelabel",
         hideLabel: "Skjul powered by tekst",
         hideHelp: "Fjern vores branding fra din butikslokator"
       }
    },
    languages: {
      title: "Sprog",
      error: "Fejl...",
      messages: {
        savedSuccessfully: "Sprogindstillinger gemt med succes",
        couldntSave: "Kunne ikke gemme sprogindstillinger"
      },
      banner: {
        upgradeTitle: "Flersproget support kræver planopgradering",
        upgradeAction: "Opgrader til Superest",
        upgradeMessage: "Du kan stadig ændre dit standardsprog, men aktivering af flere sprog kræver en opgradering.",
        disabledMessage: "Flersprogede indstillinger er deaktiveret på din nuværende plan"
      },
      defaultLanguage: {
        title: "Standardsprog", 
        description: "Vælg dit primære sprog, som dit indhold vil blive vist på.",
        label: "Standardsprog",
        help: "Dette sprog vil blive brugt, når der ikke anmodes om et specifikt sprog"
      },
      internationalization: {
        title: "Internationalisering",
        description: "Aktiver flere sprog. Nå flere kunder og boost din SEO.",
        enableLabel: "Aktiver flere sprog",
        enableHelp: "Tillad kunder at se din butikslokator på forskellige sprog"
      },
      supportedLanguages: {
        title: "Yderligere understøttede sprog",
        description: "Vælg yderligere sprog, du vil understøtte. Når du har aktiveret et sprog, vil du se muligheden for at give oversættelser gennem hele appen. For understøttede sprog vil standard SEO-skabelonerne samt de almindelige variabeltemaer blive genereret automatisk.",
        defaultLocaleNote: "Dette er dit standardsprog og kan ikke deaktiveres",
        shopifyEnabled: {
          label: "Dette sprog er aktiveret i min Shopify butik",
          importantNote: "Vigtigt:",
          description: "Fjern markeringen fra boksen ovenfor, hvis dette sprog ikke er aktiveret og publiceret for din Shopify butik. Det anbefales at aktivere sproget for din Shopify butik først ved at gå til Indstillinger > Sprog i din Shopify admin, hvis du ikke allerede har gjort det for en glattere kundeoplevelse."
        },
        urlFormats: {
          cleanUrls: "Rene URL'er:",
          betterSeo: "Bedre SEO og brugeroplevelse",
          queryUrls: "Forespørgselsparameter URL'er:",
          considerEnabling: "Overvej at aktivere i Shopify for bedre URL'er"
        },
        preview: {
          button: "Forhåndsvisning",
          tooltip: "Forhåndsvis {{language}} butikslokator"
        },
        tooltips: {
          noTemplates: "Ingen standard SEO-skabeloner tilgængelige for dette sprog. Du kan nemt oprette brugerdefinerede oversættelser."
        }
      }
    },
    tags: {
      title: "Tags",
      addTag: "Tilføj tag",
      error: "Fejl",
      messages: {
        deletedSuccessfully: "Tags slettet med succes",
        couldntDelete: "Tags kunne ikke slettes",
        savedSuccessfully: "Tag gemt med succes",
        couldntSave: "Kontroller venligst dine felter",
        tagDeleted: "Tag slettet med succes"
      },
      resourceName: {
        singular: "tag",
        plural: "tags"
      },
      filters: {
        anyGroup: "Enhver gruppe",
        inGroup: "I gruppe",
        tagGroup: "Tag gruppe"
      },
      appliedFilters: {
        inGroup: "I {{group}} gruppe",
        nameContains: "Tag navn indeholder {{query}}"
      },
      bulkActions: {
        deleteTag: "Slet tag",
        deleteTags: "Slet tags"
      },
      form: {
        language: "Sprog",
        title: "Titel",
        description: "Beskrivelse",
        group: "Gruppe",
        groupPlaceholder: "Vælg gruppe",
        addGroup: "Tilføj",
        editingTranslations: "Redigerer {{language}} oversættelser. Tomme felter vil vise indhold fra {{defaultLanguage}}.",
        defaultValue: "Standard: {{value}}",
        image: "Billede",
        imageUrl: "Billede URL"
      },
      actions: {
        save: "Gem",
        deleteTag: "Slet tag"
      },
      new: {
        title: "Tilføj tag",
        messages: {
          createSuccess: "Tag oprettet med succes",
          checkFields: "Kontroller venligst dine felter"
        },
        actions: {
          createTag: "Opret tag"
        }
      }
    },
    customFields: {
      title: "Tilpassede felter",
      addField: "Tilføj felt",
      error: "Fejl",
      resourceName: {
        singular: "Felt",
        plural: "Felter"
      },
      headings: {
        name: "Navn",
        contentType: "Indholdstype",
        usedIn: "Bruges i"
      },
      emptyState: {
        heading: "Opret og administrer dine tilpassede felter",
        createAction: "Opret felt",
        description: "Brug tilpassede felter til unikke attributter om dine lokationer. Disse felter kan være alt fra sociale profiler til butiksmanagers navn og email"
      },
      pluralization: {
        location: "lokation",
        locations: "lokationer"
      },
      form: {
        name: "Navn",
        contentType: "Indholdstype",
        key: "Nøgle",
        keyPrefix: "location.fields.",
        keyHelp: "Brug denne nøgle til at få adgang til en lokations {{name}} indhold i dine liquid skabeloner.",
        translations: {
          title: "Oversættelser",
          showTranslations: "Vis oversættelser",
          hideTranslations: "Skjul oversættelser",
          description: "Oversættelser er valgfrie. Tomme felter vil vise {{language}} feltnavnet.",
          nameTranslation: "Navn ({{language}})",
          defaultValue: "Standard: {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Felt gemt med succes",
        couldntSave: "Felt kunne ikke gemmes",
        deletedSuccessfully: "Felt slettet med succes",
        couldntDelete: "Felt kunne ikke slettes"
      },
      actions: {
        delete: "Slet"
      },
      new: {
        title: "Tilføj felt",
        messages: {
          savedSuccessfully: "Felt gemt med succes",
          couldntSave: "Felt kunne ikke gemmes"
        }
      },
      contentTypes: {
        text: "Tekst",
        textArea: "Tekstområde", 
        email: "Email",
        number: "Nummer",
        phoneNumber: "Telefonnummer",
        time: "Tid",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Fejl",
      changePlan: "Skift plan",
      usdPerMonth: "USD / måned",
      sections: {
        yourPlanIncludes: "Din plan inkluderer",
        nextBillingDate: "Næste faktureringsdato",
        trial: "Prøveperiode"
      },
      banners: {
        planUpdated: "Din plan er blevet opdateret",
        thankYouUpgrading: "Tak for opgraderingen!",
        letUsKnow: "Lad os vide",
        improvementText: "hvis der er noget, vi kan gøre bedre.",
        trialCancellation: {
          title: "Meddelelse om annullering af prøveperiode",
          message: "Din 14-dages gratis prøveperiode vil blive annulleret, når du opgraderer til en betalt plan."
        }
      },
      locations: {
        upTo: "Op til",
        locations: "lokationer",
        unlimited: "Ubegrænsede lokationer",
        used: "brugt",
        ofUsed: "{{used}} af {{max}} brugt"
      },
      trial: {
        daysLeft: "{{days}} dage tilbage",
        daysUsed: "{{used}} af {{total}} dage brugt",
        selectPlan: "Vælg en plan",
        currentPlan: "Nuværende plan",
        trialBadge: "Prøveperiode",
        currentBadge: "Nuværende",
        yourTrialJustStarted: "Din prøveperiode er lige startet",
        trialEndsAfterToday: "Din prøveperiode slutter efter i dag",
        trialEndsTomorrow: "Din prøveperiode slutter i morgen",
        daysLeftInTrial: "{{days}} dage tilbage i din prøveperiode",
        continueAddingLocations: "Fortsæt med at tilføje lokationer efter {{date}} ved at vælge en plan",
        selectPlanToday: "Vælg venligst en plan i dag for at fortsætte med at tilføje lokationer"
      },
      footer: {
        description: "Administrer eller ændr din Locations So Super plan. Se vores",
        termsOfService: "servicevilkår",
        and: "og",
        privacyPolicy: "privatlivspolitik"
      },
      features: {
        analytics: {
          title: "Analytics",
          description: "Find ud af hvordan folk bruger dine lokationer og hvor de søger efter"
        },
        internationalization: {
          title: "Flersproget support",
          description: "Boost SEO og nå flere kunder i målgrupper ved at aktivere flere sprog"
        },
        customThemes: {
          editLiquid: {
            title: "Rediger tema liquid skabeloner",
            description: "Vis lokationsdata på enhver måde du ønsker med adgang til tema liquid"
          },
          editStructuredData: {
            title: "Rediger forretningsstruktureret data",
            description: "Rediger hvordan Google forstår sider ved at redigere din struktureret data"
          }
        }
      },
      edit: {
        title: "Skift plan",
        allPlansInclude: "Alle planer ovenfor inkluderer",
        needingMoreLocations: "Har brug for flere lokationer?",
        footerQuestion: "Har du spørgsmål før du starter?",
        sendMessage: "send os en besked",
        allFeatures: {
          seoDirectory: {
            title: "SEO mappe og landingssider",
            description: "Opret automatisk en SEO mappe af alle dine lokationer, byer og regioner"
          },
          mapPage: {
            title: "Kortside med søgning og filter",
            description: "Søg og filtrer alle dine lokationer på et kort drevet af Mapbox"
          },
          tags: {
            title: "Tags",
            description: "Opret tags med billeder og beskrivelser og grupper dem"
          },
          openingHours: {
            title: "Åbningstider",
            description: "Sæt og vis åbningstiderne for dine lokationer"
          },
          mapStyles: {
            title: "Kortstile",
            description: "Ændr udseendet af kortene med en række forudindstillede stile"
          },
          customFields: {
            title: "Tilpassede felter",
            description: "Tilføj alle nye felter du ønsker, fra sociale links til butiksmanager"
          },
          csvUpload: {
            title: "Upload og eksport med CSV",
            description: "Upload og masse-rediger dine lokationer."
          },
          richSnippets: {
            title: "Rige snippets",
            description: "Hjælp Google med at forstå sider bedre med lokal forretningsstruktureret data"
          },
          directionsAndCalls: {
            title: "Rutevejledning og opkald",
            description: "Besøgende kan nemt få rutevejledning og ringe til lokationerne"
          },
          languageSupport: {
            title: "Sprog Support",
            description: "Skift standardsprog til noget andet end engelsk. Oversættelsesskabeloner leveres for 32 hovedsprog til nem opsætning."
          }
        }
      },
      planCard: {
        bestToCustomize: "Bedst til tilpasning",
        currentPlan: "Nuværende plan",
        chooseThisPlan: "Vælg denne plan",
        locationsSection: "Lokationer",
        featuresSection: "Funktioner",
        upTo: "Op til",
        locations: "lokationer",
        tooltipTooManyLocations: "Du har for mange lokationer og/eller aktiverede sprog for denne plan."
      },
      confirmation: {
        error: "Fejl ved bekræftelse af plan"
      }
    }
  },

  // Themes section
  themes: {
    title: "Temaer",
    currentTheme: {
      title: "Nuværende tema",
      description: "Dette er temaet kunderne ser, når de besøger din lokationsapp."
    },
    themeLibrary: {
      title: "Tema bibliotek", 
      description: "Administrer dine lokations temaer. Tilføj og publicer temaer for at ændre dit online lokations udseende."
    },
    skeleton: {
      currentThemeDescription: "Dette er temaet dine kunder ser, når de bruger din lokationsapp."
    },
    modal: {
      overrideTitle: "Overskriv nuværende tema?",
      override: "Overskriv",
      cancel: "Annuller",
      undoWarning: "Denne handling kan ikke fortrydes."
    },
    messages: {
      publishSuccess: "Tema publiceret succesfuldt",
      publishError: "Kunne ikke publicere tema",
      error: "Noget gik galt"
    },
    emptyStates: {
      settings: {
        heading: "Dette tema har ingen indstillinger",
        description: "Opret indstillinger i skabeloneditoren.",
        createSettings: "Opret indstillinger",
        upgradePlan: "Opgrader plan",
        upgradeRequired: "Opgrader plan for at oprette indstillinger"
      },
      language: {
        heading: "Dette tema har ingen sprogtermer",
        description: "Opret sprogtermer i skabeloneditoren.",
        createLanguageTerms: "Opret sprogtermer",
        upgradePlan: "Opgrader plan",
        upgradeRequired: "Opgrader plan for at oprette sprogtermer"
      }
    },
    templates: {
      categories: {
        templates: "Skabeloner",
        schemas: "Skemaer",
        styles: "Stile",
        liquidReference: "Liquid reference"
      },
      items: {
        landing: "Landing",
        directory: "Mappe",
        country: "Land",
        region: "Region",
        city: "By",
        location: "Lokation",
        language: "Sprog",
        settings: "Indstillinger",
        stylesheet: "Stylesheet"
      },
      errors: {
        errorsInTemplate: "Fejl i skabelon",
        error: "Fejl"
      },
      badges: {
        errors: "Fejl!",
        unsaved: "Ikke gemt"
      },
      actions: {
        viewTheme: "Se tema",
        discard: "Kassér",
        save: "Gem"
      }
    },
    language: {
      messages: {
        saveSuccess: "Tema sprogoversættelser gemt succesfuldt",
        saveError: "Tema kunne ikke gemmes"
      },
      form: {
        language: "Sprog",
        defaultLanguageHelp: "Dette er dit standardsprog",
        translationHelp: "Redigerer oversættelser for {{selectedLocale}}. Tomme felter vil vise indhold fra {{defaultLocale}} (dit standardsprog)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Flere sprog ikke aktiveret",
          action: "Aktiver i Indstillinger",
          description: "For at administrere oversættelser for flere sprog, aktiver internationalisering i dine sprogindstillinger. Viser i øjeblikket kun {{locale}} oversættelser."
        },
        translating: {
          title: "Oversætter fra {{from}} til {{to}}",
          description: "Alle felter du efterlader tomme vil automatisk vise {{defaultLocale}} indhold til dine kunder. Oversæt kun felterne hvor du ønsker anderledes indhold i {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Få adgang til {{category}} sprogtermer i liquid med {{code}}",
      fields: {
        // Common language fields - add specific ones as needed
        title: "Titel",
        description: "Beskrivelse",
        heading: "Overskrift",
        subheading: "Underoverskrift",
        button_text: "Knaptekst",
        link_text: "Linktekst",
        placeholder: "Pladsholder",
        label: "Etiket",
        help_text: "Hjælpetekst",
        error_message: "Fejlmeddelelse",
        success_message: "Succesmeddelelse",
        
        // Opening hours
        Monday: "Mandag",
        Tuesday: "Tirsdag",
        Wednesday: "Onsdag",
        Thursday: "Torsdag",
        Friday: "Fredag",
        Saturday: "Lørdag",
        Sunday: "Søndag",
        opening_hours_format: "Åbningstider format",
        closes_at_format: "Lukker kl. format",
        opens_at_format: "Åbner kl. format",
        opens_on: "Åbner på",
        open_24h: "Åben 24T",
        open: "Åben",
        closed: "Lukket",
        closes_at: "Lukker kl.",
        opens_at: "Åbner kl.",
        
        // Map
        search_map: "Søg kort",
        search_area: "Søg dette område",
        view_map: "Kort",
        view_list: "Liste",
        open_filters: "Filtre",
        stores_near_you: "Butikker nær dig",
        header: "Find en butik!",
        search_placeholder: "Skriv et postnummer eller adresse...",
        no_listings: "Vi beklager, vi kan ikke finde nogen lokationer for din søgning. Prøv at ændre filtrene eller søgelokationen",
        
        // Directory
        view_directory: "Butiksmappe",
        
        // Location
        get_directions: "Rutevejledning",
        call: "Ring",
        view_website: "Hjemmeside",
        email: "E-mail",
        opening_hours_header: "Åbningstider",
        description_header: "Information",
        phone_number_header: "Telefon",
        address_header: "Adresse",
        tag_groups_to_display: "Tag grupper at vise"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Generelt",
        navigation: "Navigation",
        forms: "Formularer",
        buttons: "Knapper",
        messages: "Meddelelser",
        errors: "Fejl",
        opening_hours: "Åbningstider",
        map: "Kort",
        directory: "Mappe",
        location: "Lokation"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Tema gemt succesfuldt",
        saveError: "Tema kunne ikke gemmes"
      },
      accessSettings: "Få adgang til {{category}} indstillinger i liquid med {{code}}",
      fields: {
        // Colors
        color_text: "Farve tekst",
        color_text_heading: "Farve tekst overskrift", 
        color_background: "Farve baggrund",
        color_accent: "Farve accent",
        color_text_positive: "Farve tekst positiv",
        color_text_negative: "Farve tekst negativ",
        dark_theme: "Mørkt tema",
        color_marker: "Farve markør",
        color_search_marker: "Farve søgemarkør",
        
        // Typography
        base_font_size: "Basis skriftstørrelse",
        
        // Buttons
        border_radius: "Kant radius",
        
        // Images
        aspect_ratio: "Sideforhold",
        fit: "Tilpas",
        
        // Spacing
        page_width: "Sidebredde",
        page_width_small: "Sidebredde lille",
        gutter_desktop: "Gutter desktop",
        gutter_mobile: "Gutter mobil",
        desktop_vertical_spacing: "Desktop vertikal afstand",
        mobile_vertical_spacing: "Mobil vertikal afstand",
        
        // Breakpoints
        breakpoint_xs: "Breakpoint XS",
        breakpoint_sm: "Breakpoint SM",
        breakpoint_md: "Breakpoint MD",
        
        // Map
        search_on_move: "Søg ved bevægelse",
        scroll_to_zoom: "Scroll for at zoome",
        
        // Landing page
        sidebar_width: "Sidepanel bredde",
        sidebar_min_height: "Sidepanel min højde",
        marker_image_src: "Markør billede kilde",
        show_filter_descriptions: "Vis filter beskrivelser",
        
        // Location page
        tag_groups_to_display: "Tag grupper at vise",
        tag_groups_to_display_as_icons: "Tag grupper at vise som ikoner",
        show_related_locations: "Vis relaterede lokationer",
        
        // Locations
        hide_regions: "Skjul regioner"
      },
      categories: {
        colors: "Farver",
        typography: "Typografi",
        buttons: "Knapper",
        images: "Billeder",
        spacing: "Afstand",
        breakpoints: "Breakpoints",
        map: "Kort",
        landing_page: "Landingsside",
        location_page: "Lokationsside",
        locations: "Lokationer"
      }
    },
    navigation: {
      sublimeTheme: "Sublime Tema",
      settings: "Indstillinger",
      language: "Sprog",
      templates: "Skabeloner",
      changeTheme: "Skift tema",
      viewDirectory: "Se mappe",
      viewLandingPage: "Se landingsside"
    },
    card: {
      lastUpdated: "Sidst opdateret",
      view: "Se",
      customize: "Tilpas",
      publish: "Publicer",
      actions: "Handlinger"
    }
  },

  // Analytics section
  analytics: {
    title: "Analytics",
    timePeriods: {
      last7days: "Sidste 7 dage",
      last30days: "Sidste 30 dage"
    },
    comparison: {
      compareToPrevious: "Sammenlign med forrige periode",
      stopComparing: "Stop sammenligning med forrige periode"
    },
    sections: {
      searchLocations: "Søg lokationer"
    },
    cards: {
      sessions: "Sessioner",
      topSearches: "Top søgninger",
      topLandingPageType: "Top landingsside type",
      topPageViewsBySession: "Top sidevisninger pr. session",
      topLocations: "Top lokationer",
      topReferrers: "Top henvisninger",
      searches: "Søgninger",
      topLandingPagesBySession: "Top landingssider pr. session"
    },
    chartLabels: {
      desktop: "Desktop"
    }
  },

}; 